// extracted by mini-css-extract-plugin
export default {"deregisterAction":"CdmHeaderActions_deregisterAction__DzV8h","deregisterButton":"CdmHeaderActions_deregisterButton__aONWR"};